// gavion.email.common.* — shared email UI copy (owned by Task 9).
export const commonMessages = {
  fr: {
    nav: "Courriels",
    tabs: {
      campaigns: "Campagnes",
      sequences: "Séquences",
      templates: "Modèles",
      segments: "Segments",
    },
    sandbox: {
      title: "Mode bac à sable SES",
      body: "Amazon SES est encore en mode bac à sable : seules les adresses vérifiées reçoivent les envois.",
      fake: "Mode simulé : aucun courriel n'est réellement envoyé.",
      not_configured:
        "Campagnes de masse : Amazon SES n'est pas encore configuré. Les séquences et les courriels individuels partent de la boîte Outlook du vendeur une fois Microsoft 365 connecté (Paramètres → Intégrations).",
    },
    actions: {
      save: "Enregistrer",
      cancel: "Annuler",
      back: "Retour",
      create: "Créer",
      edit: "Modifier",
      archive: "Archiver",
      retry: "Réessayer",
      confirm: "Confirmer",
      close: "Fermer",
    },
    states: {
      loading: "Chargement…",
      empty: "Rien à afficher pour l'instant.",
      error: "Impossible de charger les données.",
      saved: "Enregistré.",
      read_only: "Lecture seule : seuls les administrateurs peuvent modifier.",
    },
    kinds: {
      marketing: "Marketing",
      sequence: "Séquence",
      transactional: "Transactionnel",
      one_to_one: "Individuel",
    },
    languages: { fr: "Français", en: "Anglais" },
    errors: {
      forbidden: "Action réservée aux administrateurs.",
      campaign_not_found: "Campagne introuvable.",
      campaign_not_draft:
        "Seule une campagne en brouillon peut être planifiée.",
      casl_ack_required: "Cochez la confirmation LCAP avant de planifier.",
      postal_address_missing:
        "Adresse postale manquante : complétez-la dans Paramètres → Courriels.",
      template_archived: "Le modèle choisi est archivé.",
      template_draft:
        "Le modèle choisi n'est pas encore approuvé : un administrateur doit l'approuver.",
      from_domain_invalid:
        "L'adresse d'expédition doit appartenir au domaine d'envoi configuré.",
      daily_cap_invalid:
        "Le plafond quotidien doit être un nombre entier positif.",
      daily_cap_too_high:
        "Le plafond quotidien dépasse la limite fixée dans les paramètres.",
      invalid_transition: "Cette action n'est pas possible dans l'état actuel.",
      campaign_not_editable:
        "Seule une campagne en brouillon peut être modifiée.",
      campaign_must_start_draft:
        "Une nouvelle campagne doit commencer en brouillon.",
      status_via_rpc_only:
        "Le statut se change uniquement avec les commandes prévues.",
      no_email: "Aucune adresse courriel.",
      suppressed: "Désabonné / ne pas contacter.",
      no_consent: "Aucun consentement valide pour cette adresse.",
      sequence_not_found: "Séquence introuvable.",
      sequence_disabled: "Cette séquence est désactivée.",
      sequence_empty: "Cette séquence n'a aucune étape.",
      invalid_email: "Adresse courriel invalide.",
      invalid_basis: "Base de consentement invalide.",
      evidence_required:
        "La preuve est obligatoire pour un consentement exprès.",
      invalid_date: "Date invalide.",
      future_date: "La date ne peut pas être dans le futur.",
      segment_invalid: "Les conditions du segment sont invalides.",
      segment_not_found: "Segment introuvable.",
      segment_unknown_field: "Le segment utilise un champ inconnu.",
      segment_bad_condition: "Une condition du segment est invalide.",
      segment_bad_entity: "Type de segment invalide.",
      template_missing: "Modèle introuvable.",
      invalid_token: "Lien invalide ou expiré.",
      rate_limited: "Trop de tentatives. Réessayez dans quelques minutes.",
      invalid_link: "Lien invalide.",
      ses_not_configured:
        "L'envoi de courriels n'est pas encore configuré (Amazon SES).",
      send_failed: "L'envoi a échoué. Réessayez plus tard.",
      template_invalid:
        "Le modèle ne peut pas être composé : vérifiez son contenu et les paramètres courriel.",
      company_not_found: "Prospect introuvable.",
      stop_request_not_found: "Demande d'arrêt introuvable.",
      stop_request_gone: "Cette personne a été effacée : rien à confirmer.",
      invalid_starters: "Les séquences de départ sont invalides.",
      invalid_source: "Choisissez où l'adresse est publiée.",
      invalid_url: "Le lien doit commencer par https:// ou http://.",
      invalid_via: "Origine de l'action inconnue.",
      no_companies: "Aucune compagnie sélectionnée.",
      too_many: "Trop de compagnies à la fois : sélectionnez-en moins.",
      // GAVION video-campaign
      attachments_missing:
        "Le courriel 1 de cette campagne doit avoir sa pièce jointe (la vidéo) : ajoutez-la au modèle d'abord.",
      already_enrolled:
        "Cette compagnie a déjà reçu cette campagne : elle n'est jamais envoyée deux fois.",
      casl_footer_missing:
        "Le pied de page LCAP est absent du courriel : ajoutez-le au modèle.",
      unsubscribe_not_configured:
        "Le lien de désabonnement n'est pas configuré : contactez un administrateur.",
      // GAVION sequence-auto-enroll
      per_day_invalid: "Le nombre par jour doit être un entier de 1 à 200.",
      auto_enroll_invalid: "Réglage d'inscription automatique invalide.",
      unknown: "Une erreur est survenue. Réessayez.",
    },
  },
  en: {
    nav: "Emails",
    tabs: {
      campaigns: "Campaigns",
      sequences: "Sequences",
      templates: "Templates",
      segments: "Segments",
    },
    sandbox: {
      title: "SES sandbox mode",
      body: "Amazon SES is still in sandbox mode: only verified addresses receive messages.",
      fake: "Simulated mode: no email is actually sent.",
      not_configured:
        "Bulk campaigns: Amazon SES is not configured yet. Sequences and one-to-one emails go out from the rep's Outlook mailbox once Microsoft 365 is connected (Settings → Integrations).",
    },
    actions: {
      save: "Save",
      cancel: "Cancel",
      back: "Back",
      create: "Create",
      edit: "Edit",
      archive: "Archive",
      retry: "Retry",
      confirm: "Confirm",
      close: "Close",
    },
    states: {
      loading: "Loading…",
      empty: "Nothing to show yet.",
      error: "Could not load the data.",
      saved: "Saved.",
      read_only: "Read-only: only administrators can make changes.",
    },
    kinds: {
      marketing: "Marketing",
      sequence: "Sequence",
      transactional: "Transactional",
      one_to_one: "One-to-one",
    },
    languages: { fr: "French", en: "English" },
    errors: {
      forbidden: "Administrators only.",
      campaign_not_found: "Campaign not found.",
      campaign_not_draft: "Only a draft campaign can be scheduled.",
      casl_ack_required: "Tick the CASL confirmation before scheduling.",
      postal_address_missing:
        "Postal address missing: fill it in under Settings → Emails.",
      template_archived: "The selected template is archived.",
      template_draft:
        "The selected template is not approved yet: an administrator must approve it.",
      from_domain_invalid:
        "The sender address must use the configured sending domain.",
      daily_cap_invalid: "The daily cap must be a positive whole number.",
      daily_cap_too_high: "The daily cap exceeds the limit set in settings.",
      invalid_transition: "This action is not possible in the current state.",
      campaign_not_editable: "Only a draft campaign can be edited.",
      campaign_must_start_draft: "A new campaign must start as a draft.",
      status_via_rpc_only:
        "The status can only change through the provided commands.",
      no_email: "No email address.",
      suppressed: "Unsubscribed / do not contact.",
      no_consent: "No valid consent for this address.",
      sequence_not_found: "Sequence not found.",
      sequence_disabled: "This sequence is disabled.",
      sequence_empty: "This sequence has no steps.",
      invalid_email: "Invalid email address.",
      invalid_basis: "Invalid consent basis.",
      evidence_required: "Evidence is required for express consent.",
      invalid_date: "Invalid date.",
      future_date: "The date cannot be in the future.",
      segment_invalid: "The segment conditions are invalid.",
      segment_not_found: "Segment not found.",
      segment_unknown_field: "The segment uses an unknown field.",
      segment_bad_condition: "A segment condition is invalid.",
      segment_bad_entity: "Invalid segment type.",
      template_missing: "Template not found.",
      invalid_token: "Invalid or expired link.",
      rate_limited: "Too many attempts. Try again in a few minutes.",
      invalid_link: "Invalid link.",
      ses_not_configured: "Email sending is not configured yet (Amazon SES).",
      send_failed: "Sending failed. Try again later.",
      template_invalid:
        "The template cannot be composed: check its content and the email settings.",
      company_not_found: "Lead not found.",
      stop_request_not_found: "Stop request not found.",
      stop_request_gone: "This person was erased: nothing to confirm.",
      invalid_starters: "The starter sequences are invalid.",
      invalid_source: "Choose where the address is published.",
      invalid_url: "The link must start with https:// or http://.",
      invalid_via: "Unknown action origin.",
      no_companies: "No lead selected.",
      too_many: "Too many leads at once: select fewer.",
      // GAVION video-campaign
      attachments_missing:
        "Email 1 of this campaign must carry its attachment (the video): add it to the template first.",
      already_enrolled:
        "This lead already received this campaign: it is never sent twice.",
      casl_footer_missing:
        "The CASL footer is missing from the email: add it to the template.",
      unsubscribe_not_configured:
        "The unsubscribe link is not configured: contact an administrator.",
      // GAVION sequence-auto-enroll
      per_day_invalid:
        "The number per day must be a whole number from 1 to 200.",
      auto_enroll_invalid: "Invalid automatic enrolment setting.",
      unknown: "Something went wrong. Try again.",
    },
  },
} as const;
